import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { ShieldCheck } from 'lucide-react';
export function ValueSummary() {
  const items = [{
    name: 'Sistema de Sanación Emocional Integral (3 en 1)',
    value: 18000
  }, {
    name: '100+ preguntas terapéuticas guiadas',
    value: 8000
  }, {
    name: 'Método identificación de patrones repetitivos',
    value: 4990
  }, {
    name: 'Enfoque integrado mente + conducta + cuerpo',
    value: 4000
  }, {
    name: 'Bono 1 — Guía Inicio Express',
    value: 4990
  }, {
    name: 'Bono 2 — Checklist Desbloqueo Diario',
    value: 5990
  }, {
    name: 'Bono 3 — Audio Conexión Profunda',
    value: 6990
  }];
  return <section className="w-full px-4 py-6 md:py-10 bg-background" data-id="element-155">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl p-5 md:p-7 shadow-md border border-gray-100 space-y-5" data-id="element-156">
        {/* Header */}
        <div className="text-center space-y-1" data-id="element-157">
          <span className="inline-block bg-accent/10 text-accent font-bold px-3 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-158">
            Oferta solo por hoy
          </span>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main" data-id="element-159">
            Todo lo que recibís hoy
          </h2>
        </div>

        {/* Item list */}
        <div className="space-y-1" data-id="element-160">
          {items.map((item, index) => <div key={index} className="flex justify-between items-center py-1.5 border-b border-gray-50 last:border-0" data-id="element-161">
              <span className="text-text-main text-xs md:text-sm font-medium pr-2" data-id="element-162">
                {item.name}
              </span>
              <span className="text-text-muted text-xs md:text-sm font-bold whitespace-nowrap" data-id="element-163">
                <PriceDisplay amount={item.value} data-id="element-164" />
              </span>
            </div>)}
        </div>

        {/* Price box */}
        <div className="bg-background rounded-lg p-4 space-y-2 border border-gray-100" data-id="element-165">
          <div className="flex justify-between items-center text-text-muted text-sm font-bold" data-id="element-166">
            <span data-id="element-167">Valor total</span>
            <span className="line-through decoration-pain/50" data-id="element-168">
              <PriceDisplay amount={52960} data-id="element-169" />
            </span>
          </div>
          <div className="flex justify-between items-center text-xl md:text-2xl font-serif font-bold text-text-main pt-2 border-t border-gray-200" data-id="element-170">
            <span data-id="element-171">Tu precio hoy</span>
            <span className="text-solution" data-id="element-172">
              <PriceDisplay amount={19990} data-id="element-173" />
            </span>
          </div>
          <p className="text-center text-xs text-text-muted font-bold pt-1" data-id="element-174">
            Pago único · Sin cuotas · Acceso inmediato digital
          </p>
        </div>

        {/* CTA */}
        <a href="[CART_LINK]" className="block w-full text-center bg-accent text-white font-bold text-lg py-4 rounded-xl shadow-md active:scale-95 transition-transform" data-id="element-175">
          AGREGAR AL CARRITO →
        </a>

        {/* Urgency */}
        <p className="text-pain text-xs font-bold flex items-center justify-center gap-1" data-id="element-176">
          <span className="w-1.5 h-1.5 bg-pain rounded-full animate-pulse" data-id="element-177"></span>
          El precio sube cuando se cierren los cupos de lanzamiento
        </p>

        {/* Guarantee inline */}
        <div className="flex items-start gap-2 bg-primary/5 rounded-lg p-3 border border-primary/10" data-id="element-178">
          <ShieldCheck className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-179" />
          <div data-id="element-180">
            <p className="text-sm font-bold text-text-main" data-id="element-181">
              Garantía 30 días — Úsalo o te lo devolvemos
            </p>
            <p className="text-xs text-text-muted leading-snug mt-0.5" data-id="element-182">
              Si no sentís ningún cambio, te devolvemos el 100%.{' '}
              <strong data-id="element-183">Sin preguntas, sin dramas.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}